import { render, staticRenderFns } from "./SelfIdentification.vue?vue&type=template&id=03112e0a&"
import script from "./SelfIdentification.vue?vue&type=script&lang=ts&"
export * from "./SelfIdentification.vue?vue&type=script&lang=ts&"
import style0 from "./SelfIdentification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VHover,VIcon,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/builds/quebec-solidaire/qs_pointage_v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03112e0a')) {
      api.createRecord('03112e0a', component.options)
    } else {
      api.reload('03112e0a', component.options)
    }
    module.hot.accept("./SelfIdentification.vue?vue&type=template&id=03112e0a&", function () {
      api.rerender('03112e0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SelfIdentification.vue"
export default component.exports